module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "frontMatter"
  }, [_c('p', {
    staticClass: "p"
  }, [_c('span', [_vm._v("‘Pauperism was a status, entry to which affected not merely a part of a man’s life, but the whole of it. He became a pauper for all purposes and he carried his family with him. Paupers formed a distinct group of second class citizens, deprived of the most important rights of citizenship; firstly the loss of personal reputation, secondly, the loss of personal freedom and, thirdly, the loss of political freedom by suffering disenfranchisement.’")])]), _vm._v(" "), _c('p', {
    staticClass: "p-d"
  }, [_c('span', [_vm._v("T H Marshall, "), _c('em', {
    staticClass: "i"
  }, [_vm._v("Social Policy")]), _vm._v(", 1965")])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-c5918ae0","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/e9781783830763_fm01.vue
// module id = 69
// module chunks = 0